/**
 * Opciones de formateo de las fechas.
 * Aplica a todas las funciones de formateo de fechas `edicom.locale.datetime`...
 * como los del timezone `edicom.locale.tz.datetime`...
 *
 * El formato puede ser de 2 tipos.
 * - {object}: entonces se usara con `Intl.DateTimeFormat`
 * - {string}: entonces se parseara con `date-fns/format`
 *
 * ## Notas para tipos localizados "PPpp" ...
 * Usamos `date-fns/format` para parsear los tipos {string}, los con 'yyyy...' porque no hay equivalente en javascript.
 *
 * Sin embargo, para los tipos localizados, ej. 'PPpp', tendríamos que cargar el objeto de localización de Date-fns de cada locale que
 * queremos soportar.
 * La localización esta disponible en vanilla javascript con el objeto `Intl.DateTimeFormat`, entonces,
 * para minimizar el tamaño del bundle, pasamos de Date-fns en este caso y usamos lo nativo.
 *
 *
 * ## Documentación `Intl.DateTimeFormat`
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat
 *
 * ## Documentación `date-fns/format`
 * https://date-fns.org/v2.23.0/docs/format
 *
 * Los 3 formatos predeterminados (del frontend) son compatibles con el `format` de date-fns.
 */
export const DATEFORMATS = {
  /**
   * Formato localizado (defecto)
   *
   * ## Documentación `Intl.DateTimeFormat
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat
   */
  localized: {
    datetime: { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' }, // => 'Pp': 05/29/1453, 12:00 AM
    datetimelong: { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }, // => 'Ppp': 05/29/1453, 12:00:00 AM
    date: { year: 'numeric', month: 'numeric', day: 'numeric' }, // => 'P': 05/29/1453
    time: { hour: 'numeric', minute: 'numeric' }, // => 'p': 12:00 AM
    timelong: { hour: 'numeric', minute: 'numeric', second: 'numeric' }, // => 'pp': 12:00:00 AM
  },

  /**
   * Formato frontend: corresponde mas o menos a 'es'
   */
  'dd/MM/yyyy HH:mm:ss': {
    datetime: 'dd/MM/yyyy HH:mm',
    datetimelong: 'dd/MM/yyyy HH:mm:ss',
    date: 'dd/MM/yyyy',
    time: 'HH:mm',
    timelong: 'HH:mm:ss',
  },

  /**
   * Formato frontend: corresponde mas o menos a 'en'
   */
  'MM/dd/yyyy HH:mm:ss': {
    datetime: 'MM/dd/yyyy HH:mm',
    datetimelong: 'MM/dd/yyyy HH:mm:ss',
    date: 'MM/dd/yyyy',
    time: 'HH:mm',
    timelong: 'HH:mm:ss',
  },

  /**
   * Formato frontend: formato internacional
   */
  'yyyy/MM/dd HH:mm:ss': {
    datetime: 'yyyy/MM/dd HH:mm',
    datetimelong: 'yyyy/MM/dd HH:mm:ss',
    date: 'yyyy/MM/dd',
    time: 'HH:mm',
    timelong: 'HH:mm:ss',
  },
};
